<template>
  <v-card
    :loading="loading"
    class="pa-0"
  >
    <v-card-text class="pa-0">
      <v-data-table
        :items="itemsToShow"
        :headers="headers"
        disable-pagination
        hide-default-footer
      >
        <template #[`item.avatar`]="{ item }">
          <v-avatar size="96">
            <img :src="item.avatarUrl" />
          </v-avatar>
        </template>
        <template #[`item.style`]="{ item }">
          <v-textarea
            v-model="item.style"
            outlined
            hide-details
            auto-grow
            class="my-4"
            @blur="save(item)"
          />
        </template>
        <template #[`item.twitterHandle`]="{ item }">
          <v-text-field
            v-model="item.twitterHandle"
            outlined
            hide-details
            auto-grow
            class="my-4"
            @blur="save(item)"
          />
        </template>
        <template #[`item.linkedInHandle`]="{ item }">
          <v-text-field
            v-model="item.linkedInHandle"
            outlined
            hide-details
            auto-grow
            class="my-4"
            @blur="save(item)"
          />
        </template>
        <template #[`item.biography`]="{ item }">
          <v-textarea
            v-model="item.biography"
            outlined
            hide-details
            auto-grow
            class="my-4"
            @blur="save(item)"
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ContentAuthors',
  data() {
    return {
      loading: false,
      saving: false
    };
  },

  computed: {
    headers() {
      const list = [
        { text: 'Avatar', value: 'avatar' },
        { text: 'Name', value: 'fullName' },
        { text: 'X', value: 'twitterHandle' },
        { text: 'LinkedIn', value: 'linkedInHandle' },
        { text: 'Style', value: 'style' },
        { text: 'Bio', value: 'biography' }
      ];
      return list.filter((x) => !x.hide);
    },
    itemsToShow() {
      return this.authors;
    },
    ...mapGetters({
      authors: 'users/authors'
    })
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      Promise.all([this.$store.dispatch('users/getAuthors')])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save(item) {
      this.saving = true;
      this.$store
        .dispatch('users/updateAuthor', item)
        .then(() => {
          this.$root.$snackbarSuccess('Author updated');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
